import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// This component replaces <Input type="password" ...>
export const PasswordInput = ({ value, onChange, placeholder, required = true }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative w-full">
      <input
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="w-full rounded-md bg-[#fdf9c1] text-black px-3 py-2 pr-10 focus:outline-none"
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-3 top-2.5 text-gray-600 hover:text-white"
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};